import React from "react";
import { Link } from "react-router-dom";

const SecureTransaction = () => {
  return (
    <div className="dg__secure__transaction">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="dg__secure__inner">
              <h2>
                Experience Secure and Efficient Staking with MetaNetwork
              </h2>
              <p>
                MetaNetwork provides a secure platform for staking your crypto assets like MATIC, BNB, USDC, LINK, and ETH. With our advanced security protocols, your assets are safeguarded throughout every transaction.
              </p>
              <p>
                Enjoy peace of mind with robust security measures, transparent operations, and a user-friendly interface designed to make staking easy and efficient. Join thousands of users already earning rewards with MetaNetwork's reliable and fast staking services.
              </p>
              <Link
                className="secure__btn dg__btn btn--trans"
                to={process.env.PUBLIC_URL + "/contact"}
              >
                Start Staking Now
              </Link>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="dg__secure__thumb">
              <img
                src={process.env.PUBLIC_URL + "/images/about/c1.jpg"}
                alt="Secure Staking with MetaNetwork"
                style={{ maxWidth: '30rem' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecureTransaction;
